module.exports = __webpack_public_path__ + "img/list_box_bottom_bg.cfa9d34a.png";